const API_BASE_URL_DEV = "http://localhost:8000";
const API_BASE_URL_PROD = "https://api.sdoc.dikson.dev";
export const API_BASE_URL =
  process.env.NODE_ENV === "production" ? API_BASE_URL_PROD : API_BASE_URL_DEV;
